import ConfigService from './ConfigService';

import apiService from '../ApiService';

export default new ConfigService(apiService);
